import { action, observable, makeObservable } from 'mobx';
import { BannerComponent } from '../components/banner/banner';
import { LicenseBannerComponent } from '../components/license.banner/license.banner';
import { MessageBannerComponent } from '../components/message.banner/message.banner';
import { ModalService } from '../components/modal/modal.service';
import { NotificationService } from '../components/notification.toast/notification.service';
import { addStyles, DefaultTheme } from '../components/theme';
import { m, type MithrilVNode } from '../mithril';
import { NavDrawer } from '../modules/nav.drawer/nav.drawer';
import { NavDrawerCtrl } from '../modules/nav.drawer/nav.drawer.ctrl';
import { IkePage } from './page';

const CSS = {
	container: 'c-Page',
	banner: 'c-Page__Banner',
	content: 'c-Page__Content',
	layout: 'c-Page__Layout',
	overlay: 'c-Page__Overlay',
	constrainWidth: 'c-Page__ConstrainWidth',
};

const Style = {
	[CSS.container]: {
		'background-color': DefaultTheme.background.offWhite,
		'font-size': DefaultTheme.font.size,
		color: DefaultTheme.font.color.primary,
		'font-family': DefaultTheme.font.family,
	},

	[CSS.content]: {
		flex: 1,
	},
	'mdl-layout--fixed-drawer > .mdl-layout__content': {
		padding: DefaultTheme.space(4),
	},
	// Unrestrict height for printing across multiple pages
	'@media print': {
		[CSS.layout]: {
			height: 'auto',
			display: 'block',
		},
		[CSS.content]: {
			display: 'block',
		},
	},
};

addStyles(Style);

export const PageLayoutState = {
	nav: new NavDrawerCtrl(),
};

export class PageLayout {
	@observable.ref page: IkePage | null = null;
	private static banner: BannerComponent;
	messageBanner: MessageBannerComponent;
	licenseBanner: LicenseBannerComponent;

	constructor() {
		makeObservable(this);

		if (PageLayout.banner == null) {
			PageLayout.banner = new BannerComponent();
		}
		this.messageBanner = new MessageBannerComponent();
		this.licenseBanner = new LicenseBannerComponent();
	}

	@action setPage(page: IkePage) {
		this.page = page;
	}

	view(): MithrilVNode {
		if (this.page == null) {
			return null;
		}

		const config = this.page.config;

		return m('div', { className: `${CSS.container} mdl-layout__container` }, [
			m('div', { className: `${CSS.layout} mdl-layout ${config.layout.nav ? 'mdl-layout--fixed-drawer' : ''}` }, [
				this.messageBanner.view(),
				this.licenseBanner.view(),
				// Banner (top)
				config.layout.banner ? m('div', { className: CSS.banner }, PageLayout.banner.view()) : null,
				// Nav Drawer (left)
				NavDrawer.view(PageLayoutState.nav),
				// Content (center)
				m('div', { className: `${CSS.content} mdl-layout__content` }, this.page.view()),
				// Overlays (display over all other elements)
				m('div', { className: CSS.overlay }, [ModalService.view(), NotificationService.view()]),
			]),
		]);
	}
}
